import Head from 'next/head';
import { Banner } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { ListLoadingSkeleton } from '~/shared/components/ListLoadingSkeleton';
import { ETolgeeHome, ETolgeeNamespaces } from '~/shared/enums';

import { ActionCardGrid, EmptyHome } from '../elements';
import { useHomeActionCards } from '../hooks';

export function Page() {
  const { t } = useTranslate(ETolgeeNamespaces.HOME);
  const { cards, isLoading } = useHomeActionCards();

  return (
    <div className="flex flex-col gap-6">
      <Head>
        <title>{t(ETolgeeHome.HOME_TITLE)}</title>
      </Head>

      <Banner.Root className="rounded-lg">
        <Banner.Content>
          <Banner.Subtitle className="text-primary">
            {t(ETolgeeHome.EMPTY_HOME_BANNER_TITLE)}
          </Banner.Subtitle>
          <Banner.Title>
            {t(ETolgeeHome.EMPTY_HOME_BANNER_SUBTITLE)}
          </Banner.Title>
        </Banner.Content>
      </Banner.Root>

      {isLoading ? (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <ListLoadingSkeleton key={index} />
          ))}
        </div>
      ) : (
        <>
          {cards.length > 0 ? <ActionCardGrid cards={cards} /> : <EmptyHome />}
        </>
      )}
    </div>
  );
}
